import { Typography, useTheme } from '@mui/material';
import { TituloContentt } from './SimulationMuiComponents';

export const ContributionsSectionTitleForm = ({ textTitle }) => {
  const theme = useTheme();
  return (
    <TituloContentt>
      <Typography
        sx={{
          fontWeight: theme.typography.signInWelcome.fontWeight,
          color: theme.palette.primary.main,
          fontSize: theme.typography.h1.fontSize,
          textAlign: 'center',
          [theme.breakpoints.down('md')]: {
            fontSize: theme.typography.profile.fontSize,
            marginLeft: '0px',
          },
          [theme.breakpoints.down('sm')]: {
            fontSize: theme.typography.availableBalance.fontSize,
            marginLeft: '0px',
          },
        }}>
        {textTitle}
      </Typography>
    </TituloContentt>
  );
};
